import { useOptimizelyFlagContext } from '@/scopes/common/infrastructure/ab-testing/optimizely/useOptimizely'
import { useBreakpoints } from '@sunwebgroup/ui-components/uds'
import { useMedia } from 'react-use'

export function useCustomDesktop() {
  const { isDesktop } = useBreakpoints()
  const { productCardSplitDetails } = useOptimizelyFlagContext()

  const isCustomDesktop = useMedia(`(min-width: 1280px)`, false)

  return productCardSplitDetails ? isCustomDesktop : isDesktop
}
